import React, { FC, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { useTranslation } from 'react-i18next';
import { getHashParam } from '../../helpers/url/urlHelpers';
import { Tab, Tabs } from '../base/tabs/tabs';
import AddressSearch from './addressSearch';
import * as StyledGeneralPostInfo from './generalPostInfo.styles';
import HomeAndCompanies from './homesAndCompanies';
import LetterPostboxes from './letterPostboxes';
import ServiceLevel from './serviceLevel';

interface Props {}

const GeneralPostInfo: FC<Props> = () => {
	const { t } = useTranslation('generalPostInfo');
	const queryTab = getHashParam('tab');
	const [activeTab, setActiveTab] = useState(parseInt(queryTab, 10) || 0);

	const onTabClick = tab => {
		window.history.pushState(null, null, `#tab=${tab}`);
		setActiveTab(tab);
	};

	return (
		<StyledGeneralPostInfo.Wrapper>
			<Tabs>
				<Tab active={activeTab === 0} onClick={onTabClick.bind(null, 0)}>
					{t('service-level.service-level')}
				</Tab>
				<Tab active={activeTab === 1} onClick={onTabClick.bind(null, 1)}>
					{t('homes-and-companies.homes-and-companies')}
				</Tab>
				<Tab active={activeTab === 2} onClick={onTabClick.bind(null, 2)}>
					{t('letter-postbox.letter-postboxes')}
				</Tab>
				<Tab active={activeTab === 3} onClick={onTabClick.bind(null, 3)}>
					{t('address-search.address-search')}
				</Tab>
			</Tabs>
			<StyledGeneralPostInfo.ContentWrapper>
				<AnimateHeight
					duration={400}
					style={{ opacity: activeTab === 0 ? 1 : 0 }}
					height={activeTab === 0 ? 'auto' : 0}>
					<ServiceLevel active={activeTab === 0} />
				</AnimateHeight>
				<AnimateHeight
					duration={400}
					style={{ opacity: activeTab === 1 ? 1 : 0 }}
					height={activeTab === 1 ? 'auto' : 0}>
					<HomeAndCompanies active={activeTab === 1} />
				</AnimateHeight>
				<AnimateHeight
					duration={400}
					style={{ opacity: activeTab === 2 ? 1 : 0 }}
					height={activeTab === 2 ? 'auto' : 0}>
					<LetterPostboxes active={activeTab === 2} />
				</AnimateHeight>
				<AnimateHeight
					duration={400}
					style={{ opacity: activeTab === 3 ? 1 : 0 }}
					height={activeTab === 3 ? 'auto' : 3}>
					<AddressSearch />
				</AnimateHeight>
			</StyledGeneralPostInfo.ContentWrapper>
		</StyledGeneralPostInfo.Wrapper>
	);
};

export default GeneralPostInfo;
